import { api } from '../../api'
import type { CreateFaqRequest, Faq, FaqsResponse, UpdateFaqRequest } from '../../../types/faq.types'

export type { Faq, FaqsResponse, CreateFaqRequest, UpdateFaqRequest } from '../../../types/faq.types'

export const getFaqs = async (): Promise<Faq[]> => {
  const res = await api.get<FaqsResponse>('faq/')
  return res.data.results ?? res.data.data ?? []
}

export const createFaq = async (data: CreateFaqRequest): Promise<Faq> => {
  const res = await api.post<Faq>('faq/', data)
  return res.data
}

export const updateFaq = async (data: UpdateFaqRequest): Promise<Faq> => {
  const res = await api.put<Faq>(`faq/${data.id}/`, data)
  return res.data
}

export const deleteFaq = async (id: string): Promise<void> => {
  await api.delete(`faq/${id}/`)
}
